import styled from 'styled-components'

export const PdfButtonStyled = styled.div`
  button {
    background-color: #A0D6FF !important;
    border: none !important;
    color: #00477d !important;
    
    &:hover:not(:disabled) {
      background-color: #8BC9FF !important;
      color: #00477d !important;
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`

